const Environment = {
	serverUrl: process.env.REACT_APP_SERVER_URL,
	captchaSiteKey: process.env.REACT_APP_CAPTCHA_SITE_KEY
}

export default Environment;
